import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackShade19,
  blackShade21,
  blueColor04,
  border25,
  copyBtnColor,
  greyColor40,
  greyColor42,
  outOfStockColor,
  perpleBgColor11,
  whiteColor,
  yellowShade01,
  yellowShade02,
  yellowShade03,
} from "../../../configs/styles/muiThemes";
import { textTwoLines } from "../../../utils/styles";

function VariantMainProductCard({
  img,
  originalAmt,
  amt,
  priceOff,
  ondcEnabled,
  productName,
  active,
  onMainProductClick,
  count,
}) {
  return (
    <Box
      display="flex"
      gap={1}
      p={"10px"}
      border={border25}
      backgroundColor={active ? greyColor42 : whiteColor}
      sx={{ cursor: "pointer" }}
      onClick={onMainProductClick}
    >
      <Box component="img" src={img} sx={styles.imgContainer} />
      <Stack gap={0.5}>
        <Typography
          fontSize={{ xs: 13, md: 12.5 }}
          color={blackColor}
          fontWeight={{ xs: 600, md: 500 }}
          lineHeight={1.5}
          mb="0px !important"
          sx={{ ...textTwoLines }}
        >
          {productName}
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          columnGap={1}
          rowGap={0.5}
          flexWrap={"wrap"}
        >
          <Typography
            fontSize={11}
            color={blackShade21}
            sx={{
              textDecoration: "line-through",
            }}
          >
            ₹ {originalAmt || "100"}
          </Typography>

          <Typography fontSize={12} fontWeight={600} color={blueColor04}>
            ₹ {amt || "100"}
          </Typography>

          <Box sx={styles.percentageOffTag}>{priceOff} %</Box>

          <Typography fontSize={11.5} fontWeight={400} color={greyColor40}>
            ONDC Enabled :{" "}
            <span
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: ondcEnabled ? copyBtnColor : outOfStockColor,
              }}
            >
              {/* {toTitleCase(ondcEnabled || "No")} */}
              {ondcEnabled ? "Yes" : "No"}
            </span>
          </Typography>
        </Box>
        <Box display={"flex"} gap={1}>
          <Typography fontSize={11.5} fontWeight={400} color={greyColor40}>
            No of Variants
          </Typography>
          <Box sx={styles.variantCount(active)}>{count}</Box>
        </Box>
      </Stack>
    </Box>
  );
}

export default VariantMainProductCard;

const styles = {
  imgContainer: {
    width: "40px",
    height: "40px",
    borderRadius: "6px",
    border: border25,
    backgroundColor: whiteColor,
  },
  percentageOffTag: {
    fontSize: 11,
    fontWeight: 600,
    color: yellowShade01,
    bgcolor: yellowShade02,
    border: "1px solid" + yellowShade03,
    p: "0px 5px",
    borderRadius: "4px",
  },
  variantCount: (active) => ({
    backgroundColor: active ? whiteColor : perpleBgColor11,
    color: blackShade19,
    p: "0px 13px",
    borderRadius: "50px",
    fontSize: 12,
    fontWeight: 600,
  }),
};
